module.exports = __webpack_public_path__ + "static/img/unlocked.259bd7a8.svg";